
import AbsoluteFrecuency from './AbsoluteFrecuency'
import CumulativeFrecuency from './CumulativeFrecuency'


import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

import GaugeChart from 'react-gauge-chart';
import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import highchartsMore from "highcharts/highcharts-more.js";
import solidGauge from "highcharts/modules/solid-gauge.js";

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import DevicesIcon from '@material-ui/icons/Devices';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import RefreshIcon from '@material-ui/icons/Refresh';
import TabletMacIcon from '@material-ui/icons/TabletMac';
import WarningSharpIcon from '@material-ui/icons/WarningSharp';
import CircularProgress from '@material-ui/core/CircularProgress';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import InfoIcon from '@material-ui/icons/Info';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import { Doughnut } from 'react-chartjs-2';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import HelpIcon from '@material-ui/icons/Help';

// Palette
import palette from 'theme/palette';


// Component styles
import styles from './styles';
import { Paper } from '@material-ui/core';
import {api_host} from '../../../../common/globals/constants'
import Grid from '@material-ui/core/Grid';

import moment from 'moment-timezone'
import 'moment/locale/es'
moment.locale('es')

const REFRESH_TIME = 300000


class Statistics extends Component {
    constructor(props) {
        
        var statePeriod={}
        var periodical=false
        var typePeriod=4
        var schedule=0
        var scheduleName="Todo Horario"
        var typeGraph=0;
        if(props.periodical===true || props.online==true){
            var year=String(props.year)
            var month=String(props.indexMonth+1)
            const begin=(moment(year+'-'+month+'-01')._d)
            const final= (moment(begin).add(1,'months')._d)
            var schedules=JSON.parse(sessionStorage.getItem("horarios"))
            periodical=true
            statePeriod={startDate: begin,endDate: final,key: "selection"}
            typePeriod=props.typePeriod
            schedule=props.schedule
            typeGraph=props.typeGraph
            scheduleName=(schedules.filter(i=>i.horario_id==props.schedule))[0]["nombre"]
        }

        if(props.period === 'c' && props.online==true) {
            
            var date = props.statePeriodStatistics
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
            typePeriod=props.typePeriod
            schedule=props.schedule
            typeGraph=props.typeGraph
        }
        //console.log(props)
        super(props);
        this.handleAbsoluteFrecuencyClick = this.handleAbsoluteFrecuencyClick.bind(this);
        this.handleCumulativeFrecuencyClick = this.handleCumulativeFrecuencyClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        this.state = {
            typeGraph: typeGraph,
            period: this.props.period,
            step: this.props.location.state.fromObjective.Pasos[0].id_paso,
            isForStep: false,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: statePeriod,
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            nameGraph: [' Frecuencia Absoluta', ' Frecuencia Acumulada'],
            namePeriodPorlet: ['Última Hora', 'Último Día', 'Última Semana', 'Custom', 'Últimas 3 Horas', 'Últimos 3 Días'],
            typePeriod: typePeriod,
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: this.props.automaticUpdate,
            date: new Date(),
            periodical:periodical,
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, h:mm:ss a")),
            isOneHour: false,
            schedule:0,
            scheduleName:scheduleName,
            detalleGraph:[' Corresponde a la cantidad de mediciones para cada tiempo de respuesta del objetivo durante el período y horario seleccionado.', 
                        '  Corresponde a la sumatoria de mediciones del objetivo, que se encuentran en un rango inferior a un determinado tiempo de respuesta durante el período y horario seleccionado. '],
            intervalId: null,
        };
    }

    componentDidMount() {
        if (this.props.automaticUpdate) {
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }
     
    tick() {
        if(this.state.checkedA===true){
            this.setState({
                date: new Date(),
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
                isRefresh: true
            });
        }
    }

     handleChange = name=>event => {
        if (event.target.checked) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        this.setState({ 
            checkedA: event.target.checked 
        });
      };


    handleAbsoluteFrecuencyClick() {
        this.setState({
            typeGraph: 0,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
        });
    }

    handleCumulativeFrecuencyClick() {
        this.setState({
            typeGraph: 1,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
        });
    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        sessionStorage.setItem("statisticsSession",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        if (nextPeriod === 'hora' || nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 4,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: 'Rango: último día',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        }  else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 3 días',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: 'Rango: última semana',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: 'Rango: ' + statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }

    handleNextStepClick(propsStep, nextStep) {
        const prevPeriod = propsStep.period
        const prevTypeGraph = propsStep.typeGraph
        const newStep = nextStep
        if (propsStep.step !== newStep) {
            this.setState({
                typeGraph: prevTypeGraph,
                period: prevPeriod,
                step: newStep,
                isLastEvent: false
            })
        }
    }

    handleInfo(props, step) {
        this.setState({
            nameStep: step,
            x: props.x,
            y: props.y
        })
    }

    handleFirstInfo(props) {
        if (!this.state.isLastEvent && props.name !== null) {
            this.setState({
                nameStep: props.name,
                x: props.x,
                y: props.y,
                namePeriod: props.namePeriod,
                isLastEvent: true
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment: props,
            isRefresh: false
        })
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.automaticUpdate !== this.props.automaticUpdate && prevProps.refreshTime === this.props.refreshTime) {
            if (this.props.automaticUpdate) {
                clearInterval(this.state.intervalId)
                const newIntervalId = setInterval(
                    () => this.tick(),
                    this.props.refreshTime || REFRESH_TIME
                );
                this.setState({
                    intervalId: newIntervalId,
                    checkedA: this.props.automaticUpdate
                })
            } else {
                this.setState({checkedA: this.props.automaticUpdate})
                clearInterval(this.state.intervalId)
            }
        }
        if (prevProps.refreshTime !== this.props.refreshTime && this.state.checkedA) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({
                intervalId: newIntervalId,
            })
        }

        if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) {
            this.setState({
                typeGraph: 0,
                period: this.state.period,
                step: this.state.step,
                isForStep: false,
                nameStep: null,
                x: null,
                y: null,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
                periodEl: null
            })
        }
    }

    render() {
        const { classes, className, location } = this.props;
        const { typeGraph, period, step, x, y, nameStep, statePeriod, isStatePeriod, namePeriod, responseTimeGraphEl, periodEl,schedule,scheduleName,
             nameGraph, namePeriodPorlet, typePeriod, settingsEl, isRefresh,isInfo, detalleGraph,date, dateMoment, isOneHour, periodical } = this.state;

        let buttonAbsolute;
        let buttonCumulative;
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showPeriodEl = Boolean(periodEl);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);

        buttonAbsolute = <AbsoluteFrecuencyButton onClick={this.handleAbsoluteFrecuencyClick} />;
        buttonCumulative = <CumulativeFrecuencyButton onClick={this.handleCumulativeFrecuencyClick} />;

        const rootClassName = classNames(classes.root, className);
        const divStyle = {
            top: '25%',left: '21%', width:'500px'
          };
        return (
                <Portlet
                    /*  {...rest} */
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */
                            variant="h6"
                            title={this.props.title + nameGraph[typeGraph]}
                        />

                        <PortletToolbar>
                            <IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                anchorEl={settingsEl}
                                
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                onClose={this.handleCloseSettings}
                                open={showSettingsEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}>
                                <IconButton
                                    className={classes.refreshButton}
                                    variant="text"
                                    onClick={this.handleRefresh}
                                    onClose={this.handleCloseSettings}
                                >
                                    <div>
                                    <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Actualizar</Typography>
                                    </div>
                                </IconButton>
                                <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                    <div>
                                        <HelpIcon color="infoIcon"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Información</Typography>
                                    </div>
                                </IconButton>
                                <Popover
                                    anchorEl={isInfo}
                                    open={showIsInfo}
                                    onClose={this.handleCloseIsInfo}
                                >
                                    <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{detalleGraph[typeGraph]}</PortletContent>
                                </Popover>
                                <Tooltip title="Actualización Automatica">
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                color='primary'
                                            />
                                        </div>
                                    </Tooltip>

                            </Popover>
                            <Button
                                style={{color:"#353535"}}
                                variant="text"
                                onClick={this.handleShowResponseTimeGraph}
                            >
                                Gráficos <ArrowRightIcon />
                            </Button>
                            <Popover
                                anchorEl={responseTimeGraphEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleCloseResponseTimeGraph}
                                open={showResponseTimeGraphEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <div>
                                    {buttonAbsolute}
                                    {buttonCumulative}
                                </div>

                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                        <Grid
                            container
                            spacing={10}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}>
                                <PerfectScrollbar>
                                    
                                    
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        xl={12}> 
                                        {period == 'c' ?
                                            <div >
                                                <Typography   color="textSecondary" gutterBottom>
                                                    desde {statePeriod.startDate.toISOString().substring(0, 10)} hasta {statePeriod.endDate.toISOString().substring(0, 10)}
                                                </Typography>
                                                {periodical?
                                                <Typography   color="textSecondary" gutterBottom>
                                                    Horario {scheduleName}
                                                </Typography>
                                                :null
                                                }
                                            </div>
                                        : null}
                                        {<Graph
                                            typeGraph={typeGraph}
                                            period={period}
                                            step={step}
                                            onInfo={this.handleInfo}
                                            onFirstInfo={this.handleFirstInfo}
                                            statePeriod={statePeriod}
                                            isStatePeriod={isStatePeriod}
                                            isRefresh={isRefresh} 
                                            date={date}
                                            onDateMoment={this.handleDateMoment}
                                            schedule={this.state.schedule}/>}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        xl={12}>                                       
                                        <div>
                                            <Typography variant="h4" style={{fontSize:'13px',float:'left', paddingLeft:'5px', color:'#66788A'}}>
                                                {/*<h5>{namePeriod}</h5>*/}
                                                <h5>{nameStep}</h5>
                                                <h1>{y}(s)</h1>
                                                <h5>mediciones: {x}</h5>
                                            </Typography>
                                        </div>
                                        <div style={{float:"right", marginTop:"5%"}}>
                                            <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center'                                                        
                                                    }}>
                                                {/* <Typography >
                                               Última actualización:
                                               </Typography> */}
                                                
                                                <Avatar variant="rounded" className={classes.rounded}>
                                                <UpdateIcon /> 
                                                </Avatar>
                                                <Typography  className={classes.updateTime}   >
                                                      &nbsp; Última actualización: {dateMoment} 
                                                </Typography>
                                               
                                            </div>
                                        </div>
                                    </Grid>
                                    
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                    </PortletContent>
                    <PortletFooter className={classes.portletFooter}>
                        <Button  variant="h4" style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                            {namePeriodPorlet[typePeriod]} 
                            <ArrowDropDownIcon />
                        </Button>
                        <Popover
                            anchorEl={periodEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleClosePeriod}
                            open={showPeriodEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <Period  onClick={this.handlePeriodClick} periodical={periodical} period={period} typeGraph={typeGraph} isOneHour={isOneHour} />
                        </Popover>                        
                        {/*<Button
                            color="primary"
                            variant="text"
                            //onClick={this.handleShowResponseTimeGraph}
                        >
                            Información Extendida <ArrowRightIcon />
                        </Button>*/}
                        {<Popover
                            anchorEl={responseTimeGraphEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleCloseResponseTimeGraph}
                            open={showResponseTimeGraphEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <div>
                                {buttonAbsolute}
                                {buttonCumulative}
                            </div>
                            {/*<div >
                                {isForStep ? <div className="row1"><List component="div">
                                    {Object.values(location.state.fromObjectives.Pasos).map(i => (
                                    
                                        <ListItem
                                        className={classes.listItem}
                                        component="div"
                                        >
                                        <ListItemIcon
                                            className={classes.listItemIcon}
                                        >
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ secondary: classes.listItemTextSecondary }}
                                            primary={i.nombre_paso}
                                        />
                                        </ListItem>))}
                                </List>
                                </div> : null}
                                    </div>*/}

                        </Popover>}
                        
                    </PortletFooter>
                </Portlet>

        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <AbsoluteFrecuency params={props} />;
    }
    if (typeGraph === 1) {
        return <CumulativeFrecuency params={props} />;
    }
}

function AbsoluteFrecuencyButton(props) {
    return (
        <Button onClick={props.onClick}>
            Absoluta
      </Button>
    );
}

function CumulativeFrecuencyButton(props) {
    return (
        <Button onClick={props.onClick}>
            Acumulada
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles))(Statistics);